import { useCreateBidOneClick } from "../../../lib/hooks/api/bid/bids/useCreateBidOneClick";
import { IconProps } from "../../../lib/icons/untitled_ui/UIcon";
import { EventData } from "../../../lib/tracking";
import Button, { ButtonType } from "../../ui/button/Button";
import { CreateBidFormOutput } from "../create_bid/CreateBidForm";

type Props = {
  defaultValues: Partial<CreateBidFormOutput>;
  createdFrom: "notice" | "lead";
  trackingData: EventData;
  onCreateBid?: (bidId: string) => void;
  buttonProps?: {
    buttonText?: string;
    buttonType?: ButtonType;
    iconProps?: IconProps | null;
    fullWidth?: boolean;
  };
};

export default function CreateBidButton({
  defaultValues,
  createdFrom,
  trackingData,
  onCreateBid,
  buttonProps = {
    buttonType: "primary",
    iconProps: null,
    fullWidth: undefined,
  },
}: Props) {
  const { createBidFromDefaultValues, isLoading, isDisabled } = useCreateBidOneClick({
    trackingData,
    createdFrom,
    defaultValues,
    onCreateBid,
  });

  return (
    <Button
      buttonType={buttonProps.buttonType}
      icon={buttonProps.iconProps?.icon}
      iconProps={{
        ...buttonProps.iconProps,
      }}
      onClick={createBidFromDefaultValues}
      loading={isLoading}
      disabled={isDisabled}
      fullWidth={buttonProps.fullWidth}
    >
      {buttonProps.buttonText ?? "Create Bid"}
    </Button>
  );
}
